FairplayerImageVue(:highlightable='highlightable' :lazy='lazy' :url='url' :resolution='resolution' :fallback-image='FairplayerFallbackImageUi.FAN' @load='onLoad')
